import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { EMPTY_FRAGMENTS } from '../../feature-player/constants/skin';

import { useFilmOtt } from './use-film-ott';

export function useSkippableFragments(contentId: string): SkippableFragment[] {
    const filmOtt = useFilmOtt(contentId);

    return (filmOtt?.onlineStreams?.streams?.[0]?.streamMeta?.skippableFragments?.filter(Boolean) ||
        EMPTY_FRAGMENTS) as SkippableFragment[];
}
